export interface JobLocation {
  streetAddress?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
}

export interface JobOpening {
  id: string;
  title: string;
  locationLabel: string;
  isRemote: boolean;
  applicantCountry?: string;
  location?: JobLocation;
  shortDescription: string;
  description: string;
  responsibilities: string[];
  requirements: string[];
  salaryMin: number;
  salaryMax: number;
  salaryCurrency: string;
  applied: string;
}

export const jobOpenings: JobOpening[] = [
  {
    id: "power-bi-senior-developer",
    title: "Senior Power BI Developer",
    locationLabel: "Dallas, TX",
    isRemote: false,
    location: {
      streetAddress: "501 Elm Street",
      city: "Dallas",
      state: "TX",
      postalCode: "75202",
      country: "US",
    },
    shortDescription:
      "Build enterprise dashboards, data models, and reporting automation for US healthcare and finance clients.",
    description:
      "Seasoft partner clients are hiring an experienced Power BI developer to design and maintain executive dashboards, optimize DAX calculations, and collaborate with stakeholders across analytics teams.",
    responsibilities: [
      "Build and maintain Power BI datasets, reports, and dashboards for business teams.",
      "Write advanced DAX and Power Query transformations for large-scale reporting.",
      "Partner with data engineers to validate source systems and refresh pipelines.",
      "Document KPIs, report logic, and support release handoff to operations teams.",
    ],
    requirements: [
      "4+ years of Power BI development in production environments.",
      "Strong SQL, dimensional modeling, and ETL understanding.",
      "Experience with Azure data stack and data governance best practices.",
      "Excellent communication and client-facing presentation skills.",
    ],
    salaryMin: 105000,
    salaryMax: 130000,
    salaryCurrency: "USD",
    applied: "14 Applied",
  },
  {
    id: "salesforce-admin-consultant",
    title: "Salesforce Administrator Consultant",
    locationLabel: "Remote (USA)",
    isRemote: true,
    applicantCountry: "US",
    shortDescription:
      "Support end-to-end Salesforce administration, automation, and user enablement across distributed business teams.",
    description:
      "Our consulting projects need a Salesforce Administrator who can streamline workflows, maintain data quality, and deliver practical solutions for sales and service teams across multiple client accounts.",
    responsibilities: [
      "Configure Salesforce objects, validation rules, and automation flows.",
      "Manage user setup, profiles, roles, and permission structures.",
      "Support integrations, sandbox deployments, and release testing cycles.",
      "Train end users and maintain clear process documentation.",
    ],
    requirements: [
      "3+ years in Salesforce administration and CRM process optimization.",
      "Salesforce Administrator certification preferred.",
      "Hands-on experience with Flow, reports, and dashboard customization.",
      "Ability to troubleshoot production issues quickly and independently.",
    ],
    salaryMin: 90000,
    salaryMax: 115000,
    salaryCurrency: "USD",
    applied: "19 Applied",
  },
  {
    id: "qa-automation-engineer",
    title: "QA Automation Engineer",
    locationLabel: "Chicago, IL",
    isRemote: false,
    location: {
      streetAddress: "125 South Clark Street",
      city: "Chicago",
      state: "IL",
      postalCode: "60603",
      country: "US",
    },
    shortDescription:
      "Create robust test automation frameworks for modern web applications and API workflows.",
    description:
      "Join a fast-paced delivery team to design automation strategy, improve release confidence, and reduce manual regression cycles for enterprise-grade applications.",
    responsibilities: [
      "Develop and maintain UI and API automation suites.",
      "Integrate automated tests into CI/CD pipelines.",
      "Create test plans for sprint features and production hotfixes.",
      "Collaborate with developers to resolve defects and improve code quality.",
    ],
    requirements: [
      "3+ years of automation testing with Selenium, Cypress, or Playwright.",
      "Experience with API testing tools and test data management.",
      "Working knowledge of Git-based workflows and CI systems.",
      "Strong analytical and debugging skills.",
    ],
    salaryMin: 95000,
    salaryMax: 120000,
    salaryCurrency: "USD",
    applied: "11 Applied",
  },
];

